<template>
  <app-dialog class="flex flex-none" color="yellow">
    <template v-slot:dialogTitle>
      <money-icn
        class="yellow-icon ml-5 mr-2"
        width="20px"
        height="20px"
        fill-rule="evenodd"
      />
      <span class="text-yellow text-lg font-bold">予算</span>
    </template>
    <template v-slot:dialogContent>
      <div class="flex flex-row mt-2">
        <BudgetFormNavigation
          v-if="!budgetDialog.isPreview"
          color="yellow"
          class="mt-6"
        >
          <template v-slot:tabContent>
            <BudgetForm />
          </template>
        </BudgetFormNavigation>
      </div>
      <BudgetPreview v-if="budgetDialog.isPreview" />
    </template>
    <template v-slot:dialogFooterActions>
      <user-circle-icn width="40px" height="40px" class="ml-1" />
      <span
        class="scrollbar text-white ml-1 leading-tight"
        style="width:120px; overflow-x:scroll; white-space:nowrap;"
        v-if="currentBudget.user"
      >
        {{ currentBudget.user.uname }}
        <br />
        {{ dayjs(currentBudget.updatedAt).format('YYYY/M/D') }}更新
      </span>
      <div class="mr-1" style="margin-left:auto">
        <AppBudgetShowPreviewBtn
          color="yellow"
          @click="validate"
          v-if="!budgetDialog.isPreview"
        />
        <template v-if="budgetDialog.isPreview">
          <AppBudgetApplyBtn
            color="yellow"
            @click="submitBudget(currentBudget?.id ?? null)"
            :hidden="budgetDialog.isPreviewRegistered"
          />
        </template>
        <button
          v-if="budgetDialog.isPreviewRegistered"
          class="ml-4 box-border h-10 border-4 border-yellow"
          style="border-radius: 20px; width: 512px;     background: rgba(0,0,0,0.5);"
          :disabled="budgetDialog.isPreviewRegistered"
          :hidden="!budgetDialog.isPreviewRegistered"
        >
          <div class="flex flex-row items-center justify-center">
            <approved-icn width="20" height="20" class="mr-1" />
            <span class="text-white text-lg font-bold leading-tight"
              >登録済</span
            >
          </div>
        </button>

        <AppBudgetShowFormBtn
          color="yellow"
          v-if="!budgetDialog.isPreviewRegistered"
          style="border-radius: 20px; width: 180px;"
          @click="showForm(false)"
          :disabled="!budgetDialog.isPreview"
        />

        <button
          v-if="budgetDialog.isPreviewRegistered"
          class="box-border h-10 bg-white border-4 border-yellow disabled:opacity-50 disabled:bg-black"
          style="border-radius: 20px; width: 180px;"
          :disabled="currentUser.role.is_authorizer"
          @click="showForm(false)"
        >
          <div class="flex flex-row items-center justify-center">
            <span>
              <edit-yellow-circle-icn class="mr-1" />
            </span>
            <div class="flex flex-row items-baseline">
              <span class="text-yellow text-lg font-bold leading-tight">
                編集
              </span>
              <span class="text-yellow text-sm font-bold leading-tight">
                する
              </span>
            </div>
          </div>
        </button>
      </div>
    </template>
  </app-dialog>
</template>

<script>
import { onUnmounted } from 'vue'
import { useDialog } from '@/services/useDialog'
import { useBudgetDialog } from '@/services/useBudgetDialog'
import { useBudgets } from '@/services/useBudgets'
import { useCurrentUser } from '@/services/useCurrentUser'
import { useBudgetForm } from '@/services/useBudgetForm'
import AppDialog from '@/components/ui/AppDialog'
import MoneyIcn from '@/assets/icons/money-circle.svg?inline'
import UserCircleIcn from '@/assets/icons/user-circle.svg?inline'
import EditYellowCircleIcn from '@/assets/icons/edit-yellow-circle.svg?inline'
import ApprovedIcn from '@/assets/icons/approved.svg?inline'
import BudgetForm from '@/components/layout/budgets/BudgetForm'
import BudgetFormNavigation from '@/components/layout/budgets/BudgetFormNavigation'
import BudgetPreview from '@/components/layout/budgets/BudgetPreview'
import AppBudgetShowPreviewBtn from '@/components/ui/AppBudgetShowPreviewBtn'
import AppBudgetShowFormBtn from '@/components/ui/AppBudgetShowFormBtn'
import AppBudgetApplyBtn from '@/components/ui/AppBudgetApplyBtn'

export default {
  name: 'BudgetDialog',

  components: {
    AppDialog,
    MoneyIcn,
    UserCircleIcn,
    ApprovedIcn,
    // CircleIcn,
    BudgetForm,
    BudgetFormNavigation,
    EditYellowCircleIcn,
    AppBudgetShowFormBtn,
    BudgetPreview,
    AppBudgetShowPreviewBtn,
    // AppTempSaveBtn,
    AppBudgetApplyBtn,
  },

  setup() {
    const { currentBudget } = useBudgets()
    const { currentUser } = useCurrentUser()
    const { budgetDialog, showPreview, showForm } = useBudgetDialog()
    const { submitBudget } = useBudgetForm()
    onUnmounted(() => {
      budgetDialog.isPreview = false
      budgetDialog.isPreviewEnabled = false
      budgetDialog.isPreviewRegistered = false
    })
    const validate = () => {
      const a = document.getElementById('budget-validate-default')
      a.click()
    }
    return {
      validate,
      ...useDialog(),
      ...useBudgets(),
      ...useBudgetDialog(),
      submitBudget,
      currentBudget,
      currentUser,
      budgetDialog,
      showPreview,
      showForm,
    }
  },
}
</script>
<style lang="scss" scoped>
.scrollbar::-webkit-scrollbar {
  display: none;
}
</style>
